import { Component } from '@angular/core';

/**
 * Demonstrate the usage of {@link TableComponent}
 */
@Component({
  templateUrl: './datatable-demo.component.html',
  styleUrls: ['./datatable-demo.component.scss'],
})
export class DatatableDemoComponent {
}



// WEBPACK FOOTER //
// ./src/app/table/datatable/datatable-demo.component.ts